import axios from "../utils/request"
import base from "./base"
import base_url from "./base_url"


const api = {
    
    get_currency_codes(params){
        return axios.get(base_url + base.get_currency_codes,params)
    },

    get_price(params){
        return axios.post(base_url + base.get_price,params)
    },
    verify_email(params){
        return axios.post(base_url + base.verify_email,params)
    },

    check_email_verification_code(params){
        return axios.post(base_url + base.check_email_verification_code,params)
    },

    puchase_form(params){
        return axios.post(base_url + base.puchase_form,params)
    },

    capture_by_paypal_user(params){
        return axios.post(base_url + base.capture_by_paypal_user,params)
    },

    capture_by_wechat_user(params){
        return axios.post(base_url + base.capture_by_wechat_user,params)
    },

    get_token(params){
        return axios.get(base_url + base.get_token,params)
    },

    get_history(params){
        return axios.get(base_url + base.get_history,params)
    }
    
}

export default api;